module.exports = __webpack_public_path__ + "static/media/feature-regular-basis-offer@3x.f3bd9adb.png";